export const RESERVED_TOP_LEVEL_PATHS = [
  'new',
  'org',
  'orgs',
  'login',
  'register',
  'settings',
  'import',
  'forgot-password',
  'reset-password',
  'two-factor',
  'waitlist',
  'docs',
  'issues',
  'pulls',
  'repositories',
  'report',
] as const

export function isReservedTopLevelPath(segment: string | undefined): boolean {
  if (!segment) return false
  return (RESERVED_TOP_LEVEL_PATHS as readonly string[]).includes(segment.toLowerCase())
}